// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container--3UiKK","header":"styles__header--1DksJ","text":"styles__text--2GpQQ"};